// App.js
import './Landing.css';
import Articles from '../Article/Articles';
import About from './About';
import Slider from '../Article/Slider';
import Contact from './Contact';
import {Services} from '../Service/Services';
import ContactInfo from '../Profile/ContactInfo'

function Home({lang="ar", account, service, search, onEtat}) {
  return (
    <div className="App">
      <Slider account={account} lang={lang} />
      <Services account={account} lang={lang} service={service} onEtat={onEtat} />
      <Articles lang={lang} account={account} search={search} />
      <ContactInfo lang={lang} service={service} />
      <About lang={lang} />
      
    </div>
  );
}

export default Home;

/*
<Contact  service={service} lang={lang} />

*/